import * as React from 'react';
import { getWeekDays, getDaysArray, getMonthName } from '@weddingspot/ws-core-components';

export interface State {
    month: number;
    day: number;
    year: number;
}

export interface Props {
    yearsRange: Array<number>;
    minDate: Array<number>;
    getDateClassname?: (date: string) => string;
}

class Calendar extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            month: new Date().getMonth(),
            day: new Date().getDay(),
            year: new Date().getFullYear(),
        };
    }

    setNextMonth(): void {
        const nextMonth = (this.state.month + 1) % 12;
        this.setState({
            month: nextMonth,
            year: nextMonth === 0 ? this.state.year + 1 : this.state.year,
        });
    }

    setPrevMonth(): void {
        const prevMonth = (this.state.month + (12 - 1)) % 12;
        this.setState({
            month: prevMonth,
            year: prevMonth === 11 ? this.state.year - 1 : this.state.year,
        });
    }

    setMonth(month: number): void {
        this.setState({
            month,
        });
    }

    setYear(year: number): void {
        this.setState({
            year,
        });
    }

    render() {
        const { getDateClassname } = this.props;
        const { month, year } = this.state;
        const todayDate = this.state.day;
        const thisYear = this.state.year;
        const thisMonth = this.state.month;

        return (
            <div className='Calendar'>
                <div className='Calendar--controls'>
                    <button className='Calendar--btn-prev' onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => this.setPrevMonth()}>
                        <i className='icon-hb-arrowleft-b' />
                    </button>
                    {getMonthName(this.state.month)} {this.state.year}
                    <button className='Calendar--btn-next' onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => this.setNextMonth()}>
                        <i className='icon-hb-arrowright-b' />
                    </button>
                </div>
                <div className='Calendar--weekdays'>
                    {getWeekDays().map((day) => (
                        <span key={day}>{day}</span>
                    ))}
                </div>
                <div className='Calendar--days'>
                    {getDaysArray(month, year).map((day, index) => (
                        <span
                            key={index}
                            className={
                                'Calendar--date ' +
                                (!!getDateClassname
                                    ? getDateClassname(
                                          (month + 1 < 10 ? '0' + (month + 1) : month + 1) +
                                              '/' +
                                              (day < 10 ? '0' + day : day) +
                                              '/' +
                                              this.state.year
                                      )
                                    : '') +
                                (month === thisMonth && year === thisYear && day === todayDate ? ' Calendar--date-today' : '')
                            }
                        >
                            {day}
                        </span>
                    ))}
                </div>
            </div>
        );
    }
}

export default Calendar;
